<template>
  <div>
    <SearchPage
      v-if="node.title && searchSite"
      :title="node.title"
      :search-id="searchSite.id"
      :has-map="searchSite.hasMap"
      :has-location-filter="searchSite.hasLocationFilter"
      :has-currently-open-filter="searchSite.hasCurrentlyOpenFilter"
      :has-special-offers-filter="searchSite.hasSpecialOffersFilter"
    />
  </div>
</template>

<script lang="ts" setup>
import { SEARCH_SITES } from '../../settings'

definePageMeta({
  name: 'search-page',
})

const route = useRoute()

const searchSite = computed(() => {
  return SEARCH_SITES.find((v) => v.id === route.meta.searchSiteId)
})

if (!searchSite.value) {
  throw createError({
    statusCode: 404,
  })
}

const { entity: node } = await useDrupalRouteQuery('singlePageApplication')

await renderPageDependencies()
</script>
